import { render, staticRenderFns } from "./CharacterCounter.vue?vue&type=template&id=589f6bf2&scoped=true&"
import script from "./CharacterCounter.vue?vue&type=script&lang=js&"
export * from "./CharacterCounter.vue?vue&type=script&lang=js&"
import style0 from "./CharacterCounter.vue?vue&type=style&index=0&id=589f6bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f6bf2",
  null
  
)

export default component.exports